// Détection de l'extension Chrome Listaki depuis app.listaki.fr / listaki.fr
// (nécessite "externally_connectable" déclaré dans le manifest de l'extension)

const EXTENSION_ID = "hjfcoldangmhamnjigjflbaaijgplpab";
export const EXTENSION_STORE_URL = `https://chromewebstore.google.com/detail/listaki/${EXTENSION_ID}`;

const DISMISS_KEY = "extensionBannerDismissedUntil";
const DISMISS_DAYS = 30;

// Chrome/Edge/autres navigateurs Chromium desktop uniquement — l'extension n'existe pas ailleurs
export const isChromiumDesktopBrowser = () => {
  const ua = navigator.userAgent;
  const isMobile = /Mobi|Android|iPhone|iPad/.test(ua);
  const isChromium = /Chrome|Chromium|Edg\//.test(ua) && !/Firefox|OPR\//.test(ua);
  return isChromium && !isMobile;
};

// Résout à true/false, ne rejette jamais
export const detectListakiExtension = () => {
  return new Promise((resolve) => {
    if (!window.chrome?.runtime?.sendMessage) {
      resolve(false);
      return;
    }

    let settled = false;
    const finish = (installed) => {
      if (settled) return;
      settled = true;
      resolve(installed);
    };

    const timeoutId = setTimeout(() => finish(false), 500);

    try {
      window.chrome.runtime.sendMessage(EXTENSION_ID, { type: "LISTAKI_PING" }, (response) => {
        clearTimeout(timeoutId);
        // chrome.runtime.lastError est normal si l'extension n'est pas installée
        finish(Boolean(response?.installed));
      });
    } catch (err) {
      clearTimeout(timeoutId);
      finish(false);
    }
  });
};

export const isExtensionBannerDismissed = () => {
  const until = Number(localStorage.getItem(DISMISS_KEY) || 0);
  return Date.now() < until;
};

export const dismissExtensionBanner = () => {
  const until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
  localStorage.setItem(DISMISS_KEY, String(until));
};
